import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator, MatSidenav, MatSnackBar, MatSort, DateAdapter } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ListSource } from '../../../../projects/ig-core/src/lib/list/list-source';
import { PagingAndSortParams } from '../../../../projects/ig-core/src/lib/list/paging-and-sort-params';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { takeUntil, delay } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ReferenceCodeService } from '../reference-code/reference-code.service';
import { ApprovalLimitSource } from './approval-limit.data.source';
import { ApprovalLimitSearchCriteria } from './approval-limit.model';
import { ApprovalLimitService } from './approval-limit.service';

@Component({
  selector: 'eng-approval-limit',
  templateUrl: './approval-limit.template.html',
  styleUrls: ['./approval-limit.style.scss'],
})

export class ApprovalLimit implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatPaginator)
  paginator: MatPaginator;

  @ViewChild(MatSort)
  sort: MatSort;

  pagingAndSortParams: PagingAndSortParams;

  dataSource: ApprovalLimitSource;
  listSource: ListSource;

  approvalLimitSearchForm: FormGroup;
  approvalLimitSearchCriteria: ApprovalLimitSearchCriteria;
  showOptions: string[] = ['ALL','GRANTED','REVOKED'];

  flexMediaWatcher: Subscription;
  currentScreenWidth: string = '';
  displayedColumns: string[] = ['user', 'productType', 'approvalLimit', 'grantStatus', 'action'];


  constructor(private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private _snackbar: MatSnackBar,
    private router: Router,
    private media: MediaObserver,
    private approvalLimitService: ApprovalLimitService,
    private referenceCodeService: ReferenceCodeService,
    private dateAdapter: DateAdapter<Date>) {
    this.flexMediaWatcher = media.media$.subscribe((change: MediaChange) => {
      if (change.mqAlias !== this.currentScreenWidth) {
        this.currentScreenWidth = change.mqAlias;
        this.setTableColumns();
      }
    });
    this.dateAdapter.setLocale('en-IN');
  }

  setTableColumns() {
    this.displayedColumns = ['user', 'productType', 'approvalLimit', 'grantStatus', 'action'];
    if (this.currentScreenWidth === 'xs') {
      this.displayedColumns = ['user', 'productType', 'action'];
    }
  };

  ngOnInit() {
    // this.getReferenceCodes()
    //Instantiate empty search form
    this.approvalLimitSearchForm = this.formBuilder.group({
      user: null,
      productType: null,
      show:'GRANTED'
    });

    //Instantiate dataSource for subscribing changes in list data
    this.dataSource = new ApprovalLimitSource(this.approvalLimitService);

    //Instantiate listSource for subscribing changes in search criteria
    this.listSource = new ListSource(this.activatedRoute, this.paginator, this.sort);

    //Subscribe to changes in search criteria
    this.listSource.getListParams().pipe(takeUntil(componentDestroyed(this)))
      .subscribe((listParams) => {
        this.pagingAndSortParams = listParams.pagingAndSortParam;
        this.getApprovalLimits('');
      });
  }

  ngOnDestroy(): void {
    this.listSource.disconnect();
  }

  getQueryParams() {
    const queryParams = this.listSource.getQueryParamWithPaginationAndSortParams();
    return queryParams;
  }

  loadApprovalLimitsPageWithParams() {
    this.router.navigate([], this.getQueryParams());
  }

  ngAfterViewInit(): void {
    //Subscribe to changes in pagination and sort criteria
    this.listSource.subscribePaginationAndSortChange()
      .pipe(takeUntil(componentDestroyed(this))).subscribe(
        () => this.loadApprovalLimitsPageWithParams());
  }

  getApprovalLimits(ApprovalSearch) {
    if(ApprovalSearch === 'onClickApprovalSearch'){
      this.pagingAndSortParams.pageIndex = 0;
    }
    this.generateApprovalLimitSearchCriteria();
    //Sorting on uid in ascending order by default 
    let sortCriteria = 'uid' + ',' + 'asc';
    //Subscribe to changes in list data
    this.dataSource.getApprovalLimits(sortCriteria, this.pagingAndSortParams.pageIndex,
      this.pagingAndSortParams.pageSize, this.approvalLimitSearchCriteria);
  }

  generateApprovalLimitSearchCriteria() {
    this.approvalLimitSearchCriteria = {
      user: this.approvalLimitSearchForm.value.user,
      productType: this.approvalLimitSearchForm.value.productType,
      grant: this.approvalLimitSearchForm.value.show
    }
    // this.getApprovalLimits('');
  }

  redirectEditApproval(approvalLimit, mode,title) {
    if (mode === 'update') {
      this.router.navigate(['admin/approval-limits/update/' + approvalLimit.uid], { queryParams: { data: JSON.stringify({ "mode": mode, "approvalLimit": approvalLimit, "title": title }) } })
    } else if (mode === 'create') {
      this.router.navigate(['admin/approval-limits/create'], { queryParams: { data: JSON.stringify({ "mode": mode, "approvalLimit": approvalLimit, "title":title }) } })
    } else {
      this.router.navigate(['admin/approval-limits/view/' + approvalLimit.uid], { queryParams: { data: JSON.stringify({ "mode": mode, "approvalLimit": approvalLimit, "title": title }) } })
    }
  }

}